import React from "react";

function Index() {
  return (
    <div className="w-full h-screen overflow-hidden mt-20">
      {/* YouTube Video Embed */}
      <iframe
        className="w-full h-full"
        src="https://www.youtube.com/embed/7IWly5FjNhI?autoplay=1&controls=0&showinfo=0&modestbranding=1&rel=0&loop=1&playlist=7IWly5FjNhI"
        title="YouTube video player"
        allow="autoplay; encrypted-media; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
}

export default Index;
